export default __webpack_public_path__ + "static/media/proxima-nova-thin.593106e5.woff2";